import localforage from "localforage";

localforage.config({
  name: "CriticalAsset",
  version: 1.0,
  storeName: "Offline",
});

export default localforage;
